var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('mdb-container',[_c('mdb-row',{staticClass:"pt-5 default-color"},[_c('mdb-col',{staticClass:"text-left"},[_c('h3',[_c('strong',[_vm._v(_vm._s(_vm.block.value.title))])]),_c('p',[_vm._v(_vm._s(_vm.block.value.text))])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }